<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Analytics
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Audit Log</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-clipboard-list me-1" style="color: #00A0C1;"></i>
                  Organisation user module activities are logged here.
               </small>
            </div>
         </div>
      </div>

      <AuditLogs />
   </div>
</template>

<script>
import AuditLogs from '@/components/Analytics/Audit Logs/AuditLogs.vue';

export default {
   components: {
      AuditLogs,
   },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>